import { render } from "./BinaryTreeEmpty.vue?vue&type=template&id=7f046de8&scoped=true&ts=true"
import script from "./BinaryTreeEmpty.vue?vue&type=script&lang=ts"
export * from "./BinaryTreeEmpty.vue?vue&type=script&lang=ts"

import "./BinaryTreeEmpty.vue?vue&type=style&index=0&id=7f046de8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f046de8"]])

export default __exports__